/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBorderCornerPill = createReactComponent("outline", "border-corner-pill", "IconBorderCornerPill", [["path", { "d": "M4 20v-5c0 -6.075 4.925 -11 11 -11h5", "key": "svg-0" }]]);

export { IconBorderCornerPill as default };
//# sourceMappingURL=IconBorderCornerPill.mjs.map
